import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from '../../../../constants'

import './style.scss'

export default class NotificationsIcon extends Component {
    static propTypes = {
        index: PropTypes.number.isRequired,
    }

    render() {
        const { index } = this.props

        return (
            <div className={'mng-grps-dialog-notifications-icon'}>
                <Tooltip
                    id={`manage-group-group-notifications-tooltip-${index}`}
                    content={<FormattedMessage id={`${LOCALE_PREFIX}.groupHasNotifications`} />}
                    position={POSITION.TOP}
                    align={ALIGN.CENTER}
                >
                    <div className={'icon'} />
                </Tooltip>
            </div>
        )
    }
}
